import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'negtive-reward-preview',
  templateUrl: './negtive-reward-preview.component.html',
  styleUrls: ['./negtive-reward-preview.component.scss']
})
export class NegtiveRewardPreviewComponent implements OnInit {
  @Input('backgroundImage') backgroundImage: string = '';
  @Input('coinIcon') coinIcon: string = '';
  @Input('imageArt') imageArt: string = '';
  @Input('color1') color1: string = '';
  @Input('color2') color2: string = ''; 
  @Input() thumbnailScale: number = 1; 
  @Input() backgroundScale: number = 1;
  @Input() isExpand: boolean = false;

  s3BucketUrl = environment.s3BucketUrl

  constructor() { }

  ngOnInit() {
  }

  resolveSrc(value: string): string {
    if (!value) {
      return '/assets/images/image-not-found-150x150.png';
    }
    const v = String(value).trim();
    if (/^(data:|https?:|blob:)/i.test(v)) {
      return v;
    }
    if (v.startsWith('/assets/')) {
      return v;
    }
    return this.s3BucketUrl + v;
  }

  getBackgroundImage(): string {
    const gradient =
      this.color1 && this.color2
        ? `linear-gradient(-225deg, ${this.color1}, ${this.color2})`
        : "";

    const image = this.backgroundImage ? `url('${this.resolveSrc(this.backgroundImage)}')` : "";

    // If both exist → image on top, gradient behind
    if (gradient && image) {
      return `${image}, ${gradient}`;
    }

    if (image) return image;
    if (gradient) return gradient;

    return "";
  }

  getBackgroundSize(): string {
    const s = this.backgroundScale && this.backgroundScale > 0 ? this.backgroundScale : 1;
    // If both image and gradient exist, specify two background-size values
    if (this.backgroundImage && this.color1 && this.color2) {
      return `${Math.round(s * 100)}% auto, cover`;
    }
    // If only image exists, scale it; otherwise default cover
    if (this.backgroundImage) {
      return `${Math.round(s * 100)}% auto`;
    }
    return "cover";
  }


}
